module.exports = __webpack_public_path__ + "img/square-caret-down.61ebe633.svg";